//Please add the language resource
const loginLog = {
  logId: 'logId',
  executorHandler: 'executorHandler',
  filePath: 'filePath',
  createTime: 'createTime',
  msg: {}
};
export default loginLog



// WEBPACK FOOTER //
// ./src/page/log/xxlJobLog/lang/xxlJobLog.en.js